<rs-general-dialog
  [visible]="visible"
  iconName="pi pi-user"
  i18n-dialogTitle
  dialogTitle="Session Expired"
  i18n-description
  i18n-confirmText
  confirmText="Ok"
  i18n-cancelText
  (confirmAction)="clearExpiredParam()"
  (visibleChange)="clearExpiredParam()"
>
  <rs-icon headerIcon [icon]="ICONS.exit"></rs-icon>
  <div i18n>Your user session has expired. Please login again to continue.</div>
</rs-general-dialog>
